module.exports = __webpack_public_path__ + "static/stocking-991e039e7b844e5147879520738520f9.png";